var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded_company_data)?_c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"align":"center","cols":"12"}},[_c('companies-list',{attrs:{"company_list":_vm.company_list_data}})],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }